{
  "nav": {
    "home": "Hjem",
    "pick": "Valg",
    "leaderboard": "Stilling",
    "profile": "Profil",
    "leagues": "Ligaer",
    "active_league": "Aktiv Liga"
  },
  "common": {
    "error_data": "Fejl ved indlæsning af data.",
    "stage": "Etape",
    "go": "AFSTED",
    "back": "← Tilbage",
    "one_day_race": "Enkeltdagsløb",
    "tomorrow": "I morgen",
    "in_days_one": "I morgen",
    "in_days_many": "Om {{count}} dage",
    "in_days_other": "Om {{count}} dage",
    "at_hours": "Kl. {{hours}}",
    "loading": "Indlæser...",
    "confirm": "BEKRÆFT",
    "logout": "LOG UD",
    "in_days": "Om {{count}} dage",
    "error_generic": "Der opstod en fejl.",
    "optional": "valgfrit",
    "tu": "DIG",
    "error_title": "Fejl",
    "send": "Send",
    "retry": "Prøv igen",
    "load_error_title": "Kunne ikke indlæse data",
    "load_error_sub": "Tjek din forbindelse og prøv igen.",
    "stale_data": "Data er muligvis forældede: viser gemte data."
  },
  "home": {
    "participants": "deltagere",
    "section_results": "Seneste resultater",
    "section_upcoming": "Kommende løb",
    "social": "Følg os på sociale medier",
    "onboarding_next": "Næste →",
    "onboarding_start": "Begynd at spille →",
    "onboarding_rules": "Læs reglerne",
    "section_picks": "Valg der mangler",
    "no_races": "Ingen løb at vælge lige nu",
    "other_picks_one": "endnu et valg at foretage →",
    "other_picks_many": "{{count}} flere valg at foretage →",
    "other_picks_other": "{{count}} flere valg at foretage →",
    "stage_results": "Stilling",
    "tab_stage": "ETAPE",
    "tab_gc": "SAMLET",
    "no_data": "Ingen data tilgængelige",
    "onboarding_step1_title": "Velkommen til Virtua Cycling!",
    "onboarding_step1_body": "Fantasyspillet for professionel cykling.",
    "onboarding_step2_title": "Sådan fungerer det",
    "onboarding_item1": "Vælg dine ryttere — Før hver etape vælger du de ryttere, du satser på. Du har tid indtil starten.",
    "onboarding_item2": "Optjen point — Dine ryttere optjener point baseret på deres faktiske placering i etapen og i den samlede stilling.",
    "onboarding_item3": "Opret din liga — Konkurrer med andre deltagere etape for etape og klatr i den samlede stilling.",
    "onboarding_step3_title": "Du er klar!",
    "onboarding_step3_body": "Du er i Virtua Cycling League, den generelle liga hvor alle spiller. Læs hele regelsættet, så du ikke går glip af noget.",
    "kofi_cta": "Kan du lide appen? Giv os en øl!",
    "jersey_gc": "Førertrøje",
    "jersey_pt": "Pointtrøje",
    "jersey_gm": "Bjergtrøje",
    "greeting": "Hej, {{name}}",
    "status_ready": "Valg bekræftet til næste etape",
    "status_todo": "Du har ikke foretaget dine valg endnu",
    "retry": "Prøv igen"
  },
  "pick": {
    "live_label": "LIVE",
    "pick_done": "Valg allerede foretaget — du kan stadig ændre dem",
    "no_pick_stage": "Der blev ikke fundet nogen valg til denne etape.",
    "error_load": "Fejl ved indlæsning af løb.",
    "loading": "Indlæser...",
    "title": "Valg",
    "no_races_title": "Ingen løb tilgængelige",
    "no_races_sub": "Der er ingen løb på programmet lige nu. Kom snart tilbage!",
    "banned_title": "Udgået af løbet",
    "banned_stages_one": "Du har sprunget 1 etape over",
    "banned_stages_many": "Du har sprunget {{count}} etaper over",
    "banned_stages_other": "Du har sprunget {{count}} etaper over",
    "banned_detail": "Du kan følge resultaterne og de andres valg, men du kan ikke deltage i denne udgave.",
    "banned_message": "Vi ses næste gang!",
    "stage_finished": "Etapen er afsluttet. Her er de foretagne valg.",
    "live_alert": "Løb i gang — opstillinger låst",
    "startlist_btn": "Startliste",
    "startlist_title": "Startliste",
    "startlist_search": "Søg startnummer eller navn",
    "startlist_dnf": "Udgået",
    "startlist_empty": "Startliste endnu ikke tilgængelig",
    "tab_insert": "Indtastning",
    "tab_summary": "Opsummering",
    "start_list_title": "Startlisten er endnu ikke klar",
    "start_list_sub": "Deltagerlisten offentliggøres snart. Kig igen senere.",
    "need_more_one": "Vælg {{count}} rytter til.",
    "need_more_many": "Vælg {{count}} ryttere til.",
    "need_more_other": "Vælg {{count}} ryttere til.",
    "error_save": "Fejl ved gemning.",
    "loading_riders": "Indlæser ryttere...",
    "draft_restored": "Kladde gendannet",
    "draft_count_one": "1 rytter gemt lokalt",
    "draft_count_many": "{{count}} ryttere gemt lokalt",
    "draft_count_other": "{{count}} ryttere gemt lokalt",
    "draft_cancel": "Annuller",
    "select_n_one": "Vælg {{count}} rytter",
    "select_n_many": "Vælg {{count}} ryttere",
    "select_n_other": "Vælg {{count}} ryttere",
    "add_rider": "+ Tilføj rytter ({{current}}/{{limit}})",
    "edit_selection": "Rediger valg",
    "apply_all": "Anvend valget på alle mine ligaer",
    "saved_for": "Gemt for: {{leagues}}",
    "flip_used": "Flip — brugt",
    "flip_available": "Flip — tilgængelig",
    "flip_remove": "Fjern",
    "flip_abbinato": "{{rider}} tilknyttet slot {{slot}}",
    "flip_confirmed": "Flip er erklæret for denne etape. Ved pointberegning vælges den bedste af de to.",
    "flip_slot_label": "Tilknyt flip til hvilket slot?",
    "flip_confirm_btn": "Bekræft flip",
    "saving": "Gemmer...",
    "confirm_pick": "BEKRÆFT VALG {{current}}/{{limit}}",
    "select_riders": "Vælg ryttere",
    "search_rider": "Søg efter rytter...",
    "no_rider_found": "Ingen rytter fundet",
    "compare_users": "Sammenlign brugere",
    "confirm": "Bekræft",
    "no_pick_found": "Ingen valg fundet.",
    "toast_multi_one": "Valg gemt for 1 liga",
    "toast_multi_many": "Valg gemt for {{count}} ligaer",
    "toast_multi_other": "Valg gemt for {{count}} ligaer",
    "toast_single": "Valg gemt!",
    "compare_with": "Sammenlign med {{names}}",
    "compare_default": "Sammenlign med andre brugere (maks {{max}})",
    "tap_to_change": "• tryk for at ændre",
    "you": "(DIG)",
    "matrix_hint": "Tryk på en rytter for at se, hvem der har valgt ham",
    "user_col": "Bruger",
    "scout_title": "Scoutingrapport",
    "scout_top_rider": "Mest valgte rytter",
    "scout_distribution": "Fordeling pr. slot",
    "scout_variety": "Ligaens variation",
    "scout_distinct": "Forskellige valgte ryttere",
    "scout_identical": "Identiske opstillinger",
    "scout_no_picks": "Foretag dine valg for at se, hvor mange der har samme opstilling som dig",
    "loading_lineups": "Indlæser opstillinger...",
    "collapse_all": "LUK ALT",
    "expand_all": "UDVID ALT",
    "no_races": "Der er ingen løb tilgængelige lige nu.",
    "add_rider_one": "+ Tilføj rytter ({{current}}/{{limit}})",
    "duplicate_rider": "{{name}} er allerede blevet brugt i en tidligere etape!",
    "draft_count": "Du har {{count}} rytter(e) gemt lokalt",
    "toast_multi": "Valg gemt for {{count}} ligaer",
    "scout_chosen_by": "Valgt af: {{names}}",
    "scout_chosen_by_others": "Valgt af: {{names}} og {{count}} andre",
    "scout_sharing": "Deler...",
    "scout_share_btn": "Del scoutingrapport",
    "scout_outsider": "Outsider",
    "scout_contrarian": "Modigste valg",
    "scout_slot": "SLOT {{n}}",
    "scout_players": "{{count}} spillere",
    "draft_unsaved_banner": "Valg ikke bekræftet — tryk på Bekræft for at gemme det",
    "draft_unsaved_title": "Valg ikke bekræftet",
    "draft_unsaved_body": "Du har et valg, der ikke er gemt. Vil du bekræfte valget, før du forlader siden?",
    "draft_exit": "Forlad uden at gemme",
    "draft_confirm_now": "Bliv og bekræft",
    "share_all": "Alle",
    "current_league": "Nuværende liga",
    "duplicate_rider_reason": "Allerede brugt: {{name}}",
    "flip_saved": "Flip gemt!",
    "flip_deleted": "Flip fjernet.",
    "flip_add_rider": "+ Tilføj flip-rytter (valgfrit)",
    "riders_count_one": "1 rytter",
    "riders_count_many": "{{count}} ryttere",
    "riders_count_other": "{{count}} ryttere",
    "riders_selected_one": "1 valgt",
    "riders_selected_many": "{{count}} valgt",
    "riders_selected_other": "{{count}} valgt",
    "search_user": "Søg efter bruger...",
    "tab_per_tappa": "Pr. etape",
    "tab_matrice": "Rytteres tilstedeværelse",
    "matrix_select_riders": "Vælg ryttere, der skal spores (maks. 5)",
    "no_picks_riepilogo": "Ingen valg fundet",
    "no_picks_riepilogo_sub": "Du har endnu ikke foretaget valg til dette løb.",
    "scout_avg_pct": "~{{pct}}% i gennemsnit",
    "scout_no_identical": "Ingen andre har samme opstilling som dig",
    "scout_identical_count_one": "1 spiller har samme opstilling som dig",
    "scout_identical_count_many": "{{count}} spillere har samme opstilling som dig",
    "scout_identical_count_other": "{{count}} spillere har samme opstilling som dig",
    "scout_share_dialog": "Scoutingrapport — {{name}}",
    "share_hidden": "+ {{count}} ANDRE SPILLERE · ÅBN APPEN",
    "no_picks_tabella": "Ingen opstilling indsendt",
    "no_picks_tabella_sub": "De andre spilleres valg vises her.",
    "flip_slot_arrow": "→ slot {{slot}}",
    "race_tag_pick": "VÆLG",
    "race_tag_live": "LIVE",
    "race_tag_done": "AFSLUTTET",
    "race_switcher_label": "Løb",
    "race_history": "Løbshistorik",
    "race_group_next": "Kommende",
    "race_group_past": "Tidligere",
    "close": "Luk",
    "prev_stage": "Forrige etape",
    "next_stage": "Næste etape",
    "stage_list_title": "Etaper",
    "matrix_chosen_by": "{{name}} · valgt af {{count}} af {{total}}",
    "matrix_clear": "Ryd valg",
    "matrix_chosen_by_a11y": "valgt af {{count}} af {{total}} spillere",
    "matrix_open_player": "Åbn {{name}}s valg",
    "sheet_chosen_by": "{{count}} af {{total}}",
    "sheet_shared": "Det samme som dig",
    "sheet_unique": "Unikt valg",
    "share_label": "VALGENE",
    "share_most_picked": "MEST VALGT",
    "share_unique_picks": "UNIKKE VALG",
    "share_unique_sub": "ryttere valgt af kun én",
    "scout2_title": "Scout",
    "scout2_originality": "DIN ORIGINALITET",
    "scout2_twin": "DIN TVILLING",
    "scout2_identical": "IDENTISKE VALG",
    "scout2_identical_sub": "spillere med samme valg",
    "scout2_bold": "Dristig",
    "scout2_balanced": "Afbalanceret",
    "scout2_aligned": "På linje",
    "scout2_in_common": "{{count}} af {{total}} til fælles",
    "scout2_none": "Ingen",
    "scout2_popularity": "Ryttere efter popularitet",
    "scout2_tap_hint": "Tryk på en rytter for at fremhæve ham i tabellen",
    "scout2_your_picks": "Dine valg",
    "scout2_also_by": "Også valgt af {{names}}",
    "scout2_only_you": "Kun dig",
    "scout2_outsiders": "Outsidere",
    "finished_banner": "Løbet er slut · du er nr. {{pos}} med {{pts}} point",
    "finished_banner_nopos": "Løbet er slut",
    "finished_cta": "Stilling",
    "scout2_like_you": "Hvem der spillede som dig",
    "scout2_twins_card": "DINE TVILLINGER",
    "scout2_same_as_you": "{{count}} med dit samme valg",
    "scout2_same_picks": "Samme valg",
    "scout2_group_count": "{{count}} spillere",
    "scout2_no_common": "Ingen ryttere til fælles med",
    "scout2_other_identical": "Andre identiske valg",
    "result_title": "Sådan gik det",
    "result_total": "Du fik {{pts}} point",
    "result_pick_line": "forudsagt {{slot}}. · kom ind som {{rank}}.",
    "result_dnf": "ikke klassificeret",
    "result_best": "Din bedste",
    "result_worst": "Kostede dig mest",
    "result_malus": "Vinderen ikke valgt",
    "result_bonus_top10": "Alle i top 10",
    "result_bonus_top15": "Alle i top 15",
    "result_winner": "Vinderen",
    "result_winner_owners": "valgt af {{count}} af {{total}}",
    "result_nobody": "Ingen havde ham",
    "result_difference": "Gjorde forskellen",
    "result_difference_sub": "dem der havde ham fik i gennemsnit {{delta}} point i forhold til de andre",
    "result_flop": "Sænkede mange",
    "result_flop_sub": "dem der havde ham fik i gennemsnit {{delta}} point i forhold til de andre",
    "rules_title": "Regler kort fortalt",
    "rules_1": "Én rytter pr. etape, tre i enkeltstart.",
    "rules_2": "En rytter kan ikke bruges to gange i samme løb.",
    "rules_3": "Springer du blot én etape over, er du ude af løbet: du kan følge med, men ikke spille.",
    "rules_flip": "Flip: kun én gang pr. løb angiver du en reserverytter; han tæller i stedet for din rytter kun hvis han kommer bedre ind.",
    "profile_flat": "Flad",
    "profile_hilly": "Kuperet",
    "profile_mountain": "Bjerg",
    "profile_itt": "Enkeltstart",
    "profile_ttt": "Holdtidskørsel",
    "view_by_rider": "Pr. rytter",
    "view_by_player": "Pr. spiller",
    "tour_summary": "{{riders}} ryttere valgt af {{players}} spillere",
    "your_pick": "Dit valg",
    "tour_your_result": "Dit resultat",
    "tour_stage_winner": "Etapevinder",
    "stage_finished_banner": "Etapen er slut · du er nr. {{pos}} på etapen ({{gap}})",
    "share_label_stage": "ETAPENS VALG",
    "share_distinct_riders": "FORSKELLIGE RYTTERE",
    "scout_t_position": "DU ER I",
    "scout_t_break": "UDBRUDDET",
    "scout_t_small": "EN LILLE GRUPPE",
    "scout_t_group": "FELTET",
    "scout_t_with": "med {{count}} spillere",
    "scout_t_alone": "kun dig",
    "scout_t_leader": "LEDEREN VALGTE",
    "scout_t_jerseys": "Trøjerne: hvad de valgte",
    "scout_t_breakaway": "I udbruddet",
    "closes_at": "Lukker {{when}}",
    "closes_in": "Lukker om {{time}}",
    "profile_title": "Højdeprofil",
    "profile_climbs": "Stigninger",
    "profile_coppi": "C = Cima Coppi",
    "profile_a11y": "Højdeprofil: {{km}} km, højeste punkt {{max}} m, {{n}} hovedstigninger",
    "profile_sprint": "S = mellemsprint",
    "profile_tap_climb": "Tryk på en stigning for detaljer",
    "profile_sprint_bonus": "Sprint · bonus",
    "climb_base": "Fod",
    "climb_summit": "Top",
    "climb_avg": "Gennemsnitlig stigning",
    "climb_length": "Længde",
    "profile_bonus": "B = bonuspunkt"
  },
  "join": {
    "back_home": "Tilbage til forsiden",
    "welcome": "Velkommen til ligaen!",
    "already_member": "Du er allerede medlem af denne liga.",
    "error": "Kunne ikke tilslutte sig ligaen.",
    "joining": "Får adgang til ligaen...",
    "success": "Adgang givet!"
  },
  "leaderboard": {
    "stage_cancelled": "Etape {{n}} aflyst: tæller ikke med i klassementet",
    "loading": "Indlæser...",
    "no_result_title": "Intet resultat",
    "no_result_sub": "Resultaterne for dette løb er endnu ikke tilgængelige.",
    "gc_rank": "Sammenlagt Stilling",
    "team_no_data": "Ingen holddata for denne etape.",
    "team_title": "HOLDSTILLING",
    "stage": "Etape {{n}}",
    "general": "Samlet",
    "stage_rank": "Etapestilling {{n}}",
    "no_data_title": "Data ikke tilgængelige",
    "no_data_sub": "Stillingen for denne etape er endnu ikke beregnet.",
    "one_day_race": "Enkeltdagsløb",
    "title": "Stilling",
    "no_data": "Ingen data tilgængelige.",
    "share": "Del",
    "jersey_tempo": "Tid",
    "jersey_punti": "Point",
    "jersey_gpm": "Bjerge",
    "tab_individual": "Individuel",
    "tab_team": "Hold",
    "share_text": "{{name}}\n\n{{text}}\n\n{{site}}",
    "sharing": "...",
    "race_tag_live": "I GANG",
    "race_tag_done": "AFSLUTTET",
    "race_tag_soon": "SNART",
    "leader_label": "I trøjen",
    "lead_over_second": "{{gap}} til nr. 2",
    "winner": "Vinder",
    "sheet_total": "I alt",
    "tie": "delt",
    "top10_count": "{{count}} i top 10",
    "has_winner": "Har vinderen",
    "my_rank": "Din placering",
    "counts_for_team": "Tæller for holdet",
    "not_counting": "Tæller ikke",
    "share_label": "STILLING",
    "gap_above": "{{gap}} til nr. {{pos}}",
    "gap_below": "{{gap}} foran nr. {{pos}}",
    "trend_up": "Op {{n}} placeringer",
    "trend_down": "Ned {{n}} placeringer",
    "trend_same": "Uændret placering",
    "sheet_by_stage": "Etape for etape"
  },
  "leagues": {
    "albo": "Æresliste",
    "no_podio": "har endnu ikke opnået podieplaceringer.",
    "victories": "Sejre",
    "second": "2. plads",
    "third": "3. plads",
    "races_count_one": "1 løb",
    "races_count_many": "{{count}} løb",
    "races_count_other": "{{count}} løb",
    "player_a": "-- Spiller A --",
    "player_b": "-- Spiller B --",
    "draws_one": "1 uafgjort",
    "draws_many": "{{count}} uafgjorte",
    "draws_other": "{{count}} uafgjorte",
    "on_races_one": "ud af 1 løb",
    "on_races_many": "ud af {{count}} løb",
    "on_races_other": "ud af {{count}} løb",
    "no_common": "Ingen fælles løb med resultater.",
    "settings": "INDSTILLINGER",
    "your_position": "Din placering",
    "stagionale": "Sæsonstilling",
    "hide": "SKJUL",
    "show_all_one": "VIS ALLE (1 mere)",
    "show_all_many": "VIS ALLE ({{count}} flere)",
    "show_all_other": "VIS ALLE ({{count}} flere)",
    "no_data": "Ingen data tilgængelige endnu.",
    "head2head": "Head to head",
    "races_count": "{{count}} løb",
    "draws": "{{count}} uafgjorte",
    "on_races": "ud af {{count}} løb",
    "show_all": "VIS ALLE ({{count}} flere)",
    "badge_empty_1": "Ingen badges endnu — æren venter på dig! 🚴",
    "badge_empty_2": "Nul præstationer indtil videre, men hvert løb er en mulighed. 💪",
    "badge_empty_3": "Stadig ingen badges — de store mestre starter fra bunden. 🏅",
    "badge_empty_4": "Det første badge er altid det sværeste. Vi er der næsten! ⚡",
    "gap_to_podium": "{{gap}} point fra podiet",
    "gap_to_prev": "{{gap}} point efter nr. {{pos}}",
    "lead_over_next": "+{{gap}} point foran nr. {{pos}}",
    "invite_title": "Spiller du alene?",
    "invite_body": "Inviter dine venner til at spille sammen i denne liga.",
    "invite_cta": "Inviter venner",
    "pick_member": "Vælg en spiller",
    "position_a11y": "Placering {{pos}}",
    "load_error": "Ligaen kunne ikke indlæses.",
    "tab_standings": "Stilling",
    "tab_stats": "Statistik",
    "tab_rivalry": "Udfordringer"
  },
  "league": {
    "member_count_one": "1 bruger i denne liga",
    "member_count_many": "{{count}} brugere i denne liga",
    "member_count_other": "{{count}} brugere i denne liga",
    "index_join": "Deltag",
    "index_create": "Opret liga",
    "manage_title": "Administrer {{name}}",
    "err_name": "Indtast et navn",
    "err_password": "Indtast en adgangskode",
    "err_creation": "Fejl ved oprettelse",
    "create_title": "Opret ny liga",
    "create": "Opret liga",
    "privacy": "Privatliv",
    "public": "Offentlig",
    "private": "Privat",
    "err_join": "Fejl, eller du er allerede tilmeldt",
    "join_title": "Deltag i en liga",
    "search_placeholder": "Søg efter navn...",
    "search": "Søg",
    "no_leagues_found": "Ingen liga fundet",
    "join_btn": "Deltag",
    "password_insert": "Indtast adgangskode:",
    "calendar_section": "Kalender",
    "calendar_desc_admin": "Administrer ligaens løb",
    "calendar_desc_user": "Løb i kalenderen",
    "manage": "Administrer",
    "view": "Vis",
    "calendar_title": "Ligakalender",
    "calendar_save_one": "Gem kalender (1 løb)",
    "calendar_save_many": "Gem kalender ({{count}} løb)",
    "calendar_save_other": "Gem kalender ({{count}} løb)",
    "races_selected_one": "1 løb valgt",
    "races_selected_many": "{{count}} løb valgt",
    "races_selected_other": "{{count}} løb valgt",
    "deselect_all": "Fravælg alle",
    "select_all": "Vælg alle",
    "loading": "Indlæser...",
    "settings_section": "Ligaindstillinger",
    "settings_name": "Ligaens navn",
    "settings_save": "Gem",
    "settings_autopick": "Autovalg",
    "settings_autopick_desc": "Hvis en bruger ikke foretager et valg, vælger systemet den bedste tilgængelige rytter fra den foregående etape.",
    "settings_team_race": "Holdløb",
    "settings_team_race_desc": "Aktiver holdtilstand for denne liga.",
    "settings_team_size": "Maks. medlemmer pr. hold",
    "settings_scoring": "Pointberegning",
    "settings_scoring_best2": "Bedste 2 — summen af de to bedste",
    "settings_scoring_avg": "Gennemsnit af alle medlemmer",
    "settings_flip": "Flip",
    "settings_flip_desc": "Hver bruger kan angive en jokerrytter til en valgfri etape. Ved pointberegningen vælges automatisk den bedste mellem den faste rytter og flippen. Kan kun bruges én gang pr. løb.",
    "invite_section": "Invitationslink",
    "invite_loading": "Indlæser...",
    "invite_copied": "Kopieret!",
    "invite_copy": "Kopier",
    "invite_share_btn": "Del",
    "members_section": "Medlemmer",
    "members_title_admin": "Medlemsadministration",
    "members_title_user": "Ligaens medlemmer",
    "leaving": "Forlader...",
    "leave": "Forlad denne liga",
    "admin_badge": "Admin",
    "remove": "Fjern",
    "pick_admin_title": "Rettelse af valg",
    "pick_admin_desc": "Rediger brugernes valg",
    "pick_admin_open": "Åbn",
    "pick_admin_save": "Gem valg",
    "pick_admin_none": "— ingen —",
    "pick_admin_search": "Søg rytter eller nummer",
    "pick_admin_retired": "udgået",
    "pick_admin_saved2": "{{set}} valg gemt, {{removed}} fjernet",
    "pick_admin_nochange": "Ingen ændringer at gemme",
    "pick_admin_undo": "Fortryd sidste rettelse",
    "pick_admin_undone": "Rettelse fortrudt",
    "pick_admin_future": "Fjernede også {{n}} valg fra kommende etaper med samme rytter",
    "pick_admin_notify": "Giv spillerne besked",
    "pick_admin_no_calendar": "Dette løb er ikke i ligaens kalender: kan ikke gemmes",
    "stats_section": "Statistik",
    "stats_participation": "Deltagelse pr. etape",
    "stats_title": "Deltagelsesstatistik",
    "stats_no_data": "Ingen data tilgængelige.",
    "stats_error": "Statistikkerne kunne ikke indlæses. Prøv igen.",
    "team_loading": "Indlæser hold...",
    "team_section": "Hold",
    "team_cancel": "Annuller",
    "team_create_btn": "+ Opret hold",
    "team_locked": "Løb i gang — holdændringer deaktiveret",
    "team_create": "Opret hold",
    "team_members_count_one": "1/{{max}} medlem",
    "team_members_count_many": "{{count}}/{{max}} medlemmer",
    "team_members_count_other": "{{count}}/{{max}} medlemmer",
    "team_invite_btn": "+ Inviter",
    "team_leave": "Forlad",
    "team_save": "Gem",
    "team_pwd_hint": "Lad stå tom for at gøre offentlig",
    "team_pending": "Afventer svar",
    "team_invite_cancel": "Annuller",
    "team_invite_section": "Inviter et medlem",
    "team_no_invitable": "Ingen medlemmer tilgængelige til invitation.",
    "team_invite_action": "Inviter",
    "team_private_label": "\"{{name}}\" er privat:",
    "team_join_action": "Deltag",
    "team_empty": "Endnu intet hold — vær den første til at oprette et!",
    "team_mine": "DIT",
    "team_join": "Deltag",
    "team_full": "Fuldt",
    "team_members": "Medlemmer",
    "join": "Deltag",
    "calendar_save": "Gem kalender ({{count}} løb)",
    "invite_share": "Del",
    "races_selected": "{{count}} løb valgt",
    "invite_desc": "Del dette link — den, der klikker, kommer direkte ind i ligaen.",
    "invite_desc_pwd": "Del dette link — den, der klikker, kommer direkte ind i ligaen med adgangskoden inkluderet.",
    "member_count": "{{count}} brugere i denne liga",
    "team_members_count": "{{count}}/{{max}} medlemmer",
    "create_name_placeholder": "F.eks.: Pedalens Venner",
    "create_password_placeholder": "Adgangskode",
    "calendar_saved": "Kalender gemt!",
    "err_name_empty": "Navnet kan ikke være tomt",
    "settings_saved": "Indstillinger gemt!",
    "pwd_public_placeholder": "Lad stå tom for en offentlig liga",
    "invite_share_title": "Deltag i {{name}} på Virtua Cycling",
    "invite_share_message": "Deltag i ligaen \"{{name}}\" på Virtua Cycling!\n{{url}}",
    "invite_regen_confirm": "Generer linket igen? Alle tidligere links holder op med at virke.",
    "invite_regenerating": "Genererer...",
    "invite_regen_btn": "Generer link igen (tilbagekalder tidligere)",
    "confirm_remove": "Fjern {{name}} fra ligaen?",
    "member_removed": "{{name}} fjernet",
    "confirm_demote": "Vil du fjerne admin-rettigheder fra {{name}}?",
    "confirm_promote": "Vil du gøre {{name}} til admin?",
    "demote_admin": "Fjern Admin",
    "promote_admin": "Admin",
    "pick_admin_saved": "{{count}} valg gemt!",
    "confirm_team_leave": "Forlad holdet?",
    "confirm_kick": "Fjern {{name}} fra holdet?",
    "team_invite_sent": "Invitation sendt!",
    "team_pwd_saved": "Adgangskode opdateret!",
    "team_name_placeholder": "Holdnavn...",
    "team_rename_placeholder": "Nyt navn...",
    "team_newpwd_placeholder": "Ny adgangskode..."
  },
  "profile": {
    "nick_title": "Kaldenavn",
    "theme_title": "Temaindstillinger",
    "theme_dark": "Mørkt",
    "theme_light": "Lyst",
    "lang": "Sprog",
    "save_lang": "Gem sprog",
    "nick_success": "Kaldenavn opdateret!",
    "nick": "Kaldenavn",
    "nick_placeholder": "Indtast kaldenavn",
    "update_btn": "Opdater",
    "pass": "Adgangskode",
    "show_pass": "Vis adgangskode",
    "update_pass": "Opdater adgangskode",
    "avatars_title": "Avatarer",
    "avatars": "Vis avatarer",
    "avatars_sub": "Slå det fra, hvis din telefon er langsom: i stedet for avatarer ser du rytternes holdtrøjer og spillernes navne. Din avatar på forsiden bliver.",
    "notif_title": "Push-notifikationer",
    "my_leagues": "Mine ligaer",
    "members_count_one": "1 medlem",
    "members_count_many": "{{count}} medlemmer",
    "members_count_other": "{{count}} medlemmer",
    "default_badge": "STANDARD",
    "set_default": "Angiv som standard",
    "leave": "Forlad",
    "settings": "Profilindstillinger",
    "hi": "Hej",
    "intro": "her kan du administrere din konto.",
    "admin_panel": "Administrationspanel",
    "theme_sub": "Synkroniseret på alle dine enheder.",
    "lang_title": "Sprog / Language",
    "security_title": "Adgang og sikkerhed",
    "security_success": "Data opdateret!",
    "notif_enabled": "Aktiver notifikationer",
    "notif_enabled_sub": "Aktiverer eller deaktiverer alle notifikationer",
    "notif_results": "Løbsresultater",
    "notif_results_sub": "Notifikation når resultaterne offentliggøres",
    "notif_startlist": "Startliste",
    "notif_startlist_sub": "Notifikation så snart startlisten er tilgængelig",
    "notif_reminder": "Påmindelse om valg",
    "notif_reminder_sub": "Modtag en påmindelse før valgene lukker",
    "notif_reminder_off": "Ingen påmindelse",
    "notif_reminder_no_pick": "Kun hvis jeg ikke har valgt endnu",
    "notif_reminder_always": "Altid",
    "notif_saving": "Gemmer...",
    "notif_saved": "Præferencer gemt!",
    "notif_error": "Fejl ved gemning",
    "nick_taken": "Kaldenavn allerede i brug",
    "pass_min_length": "Adgangskoden skal være mindst 6 tegn",
    "pass_mismatch": "Adgangskoderne stemmer ikke overens",
    "new_pass_placeholder": "Ny adgangskode",
    "league_default_updated": "Standardliga opdateret!",
    "league_leave_confirm": "Er du sikker på, at du vil forlade \"{{name}}\"?",
    "league_left": "Liga forladt.",
    "confirm_password": "Bekræft adgangskode",
    "avatar_title": "Din avatar",
    "avatar_jersey": "Trøje",
    "avatar_cap": "Kasket",
    "avatar_glasses": "Briller",
    "avatar_cyclist": "Rytter",
    "avatar_patch": "Trøjemærke",
    "avatar_saved": "Avatar gemt!",
    "avatar_save_btn": "Gem avatar",
    "rules": "Regler",
    "report_bug": "Rapporter et problem",
    "bug_sent": "Rapport sendt, tak!",
    "bug_placeholder": "Beskriv problemet...",
    "group_identity": "Identitet",
    "group_account": "Konto",
    "group_contact": "Kontakt os",
    "group_danger": "Farezone",
    "change_pass": "Skift",
    "cancel": "Annuller",
    "show_more": "Vis alle ({{count}} flere)",
    "show_less": "Vis færre",
    "delete_confirm": "Er du sikker på, at du vil slette din konto? Handlingen kan ikke fortrydes, og alle dine data slettes permanent.",
    "delete_desc": "Sletningen er permanent og fjerner alle dine data, valg, ligaer og indstillinger.",
    "delete_btn": "Slet min konto",
    "delete_league_owner": "Du har oprettet en liga med andre medlemmer: hvis du sletter din konto, forsvinder den for alle. Kontakt os for at overføre den, eller slet den først.",
    "replay_tour": "Se turen igen",
    "leave_feedback": "Giv feedback",
    "feedback_placeholder": "En idé, et forslag eller en kommentar: vi vil gerne høre fra dig...",
    "feedback_sent": "Tak for din feedback! 🙏",
    "rate_app": "Bedøm Virtua Cycling ⭐"
  },
  "login": {
    "err_nickname": "Indtast et kaldenavn",
    "err_nickname_taken": "Kaldenavn allerede i brug",
    "register_ok": "Registration completed! Check your email and confirm your account before logging in.",
    "err_email": "Indtast din e-mail",
    "forgot_sent": "E-mail sendt! Tjek din indbakke.",
    "tagline": "Tag din plads i følgevognen.",
    "tab_login": "Log ind",
    "tab_register": "Registrer",
    "forgot_hint": "Indtast din e-mail, så sender vi dig et link til at nulstille adgangskoden.",
    "email": "E-mail",
    "forgot_send": "Send link",
    "back": "← Tilbage til login",
    "nickname": "Kaldenavn",
    "password": "Adgangskode",
    "btn_login": "LOG IND",
    "btn_register": "REGISTRER",
    "forgot_pass": "Glemt adgangskode?",
    "or": "eller",
    "google_login": "Log ind med Google",
    "google_register": "Registrer med Google",
    "privacy_text": "Ved at fortsætte accepterer du vores",
    "privacy_link": "Privatlivspolitik",
    "loading": "…"
  },
  "news": {
    "title": "NYHEDER",
    "loading": "Indlæser...",
    "no_news": "Ingen nyheder tilgængelige.",
    "pinned": "Fremhævet",
    "not_found": "Artikel ikke fundet.",
    "open_external": "Åbn artiklen på {{source}}",
    "disclaimer": "Overskrifter og links stammer fra eksterne kilder: Artiklerne tilhører de respektive udgivere.",
    "tab_unread_one": "{{count}} ny nyhed",
    "tab_unread_other": "{{count}} nye nyheder",
    "load_error": "Vi kunne ikke indlæse nyhederne."
  },
  "reset_password": {
    "title": "NY ADGANGSKODE",
    "subtitle": "Vælg en ny adgangskode til din konto",
    "show_pass": "Vis adgangskode",
    "loading": "Kontrollerer link...",
    "success": "Adgangskode opdateret! Du bliver omdirigeret..."
  },
  "confirm": {
    "verifying": "Kontrollerer...",
    "error": "Fejl under bekræftelse.",
    "success": "E-mail bekræftet! Du bliver omdirigeret...",
    "missing_params": "Manglende parametre i linket.",
    "missing_params_detail": "Sørg for, at du har klikket på det korrekte link fra din e-mail.",
    "critical_error": "Kritisk forbindelsesfejl."
  },
  "notifications": {
    "title": "Notifikationer",
    "empty": "Endnu ingen notifikationer",
    "accept": "Accepter",
    "refuse": "Afvis",
    "now": "Lige nu",
    "minutes_ago": "for {{count}} min siden",
    "hours_ago": "for {{count}} t siden"
  },
  "quiz": {
    "card_sub": "10 spørgsmål om Tour de France — hvor meget ved du?",
    "loading": "Indlæser spørgsmål...",
    "no_questions": "Ingen spørgsmål tilgængelige",
    "question_count": "Spørgsmål {{current}} af {{total}}",
    "easy": "Let",
    "medium": "Middel",
    "hard": "Svær",
    "correct": "Korrekt svar!",
    "wrong": "Forkert. Svaret var: {{answer}}",
    "next": "Næste",
    "see_result": "Se resultat",
    "restart": "Spil igen",
    "result_excellent": "Du er en sand cykelekspert!",
    "result_good": "Fremragende kendskab til Tour de France!",
    "result_average": "Rimeligt kendskab. Se flere løb!",
    "result_poor": "Der er plads til forbedring — men det er derfor, man cykler!"
  },
  "person": {
    "hint": "Vælg, hvordan din avatar ser ud: du ser den på startsiden.",
    "gender": "Køn",
    "man": "Mand",
    "woman": "Kvinde",
    "hair_short": "Kort",
    "hair_curly": "Krøllet",
    "hair_wavy": "Bølget",
    "hair_shaved": "Barberet",
    "hair_pixie": "Pixie",
    "hair_bob": "Bob",
    "headwear": "Hovedbeklædning",
    "wear_none": "Ingen",
    "wear_cap": "Kasket",
    "wear_helmet": "Hjelm",
    "glasses": "Briller",
    "glasses_off": "Nej",
    "glasses_on": "Ja",
    "jersey": "Trøje",
    "jersey_vertical": "Lodret",
    "jersey_horizontal": "Vandret",
    "jersey_classic": "Klassisk",
    "jersey_diagonal": "Diagonal",
    "jersey_dots": "Prikker",
    "row_skin": "Hud",
    "row_hair": "Hår",
    "row_brow": "Øjenbryn",
    "row_iris": "Øjne",
    "row_wear": "Hovedbeklædning",
    "row_visor": "Skygge",
    "row_vents": "Ventilationsåbninger",
    "row_frame": "Brillestel",
    "save": "GEM",
    "saved": "Avatar gemt",
    "save_error": "Fejl ved lagring",
    "reset": "Nulstil",
    "reset_done": "Nulstillet",
    "tab_face": "Ansigt",
    "tab_hair": "Hår",
    "tab_gear": "Tilbehør",
    "tab_jersey": "Trøje",
    "row_lens": "Glas",
    "jersey_body": "Krop",
    "jersey_sleeves": "Ærmer",
    "jersey_band": "Bånd",
    "jersey_trim": "Krave og manchetter",
    "view_mine": "Min avatar",
    "view_world_champion": "Regnbuetrøje",
    "world_champion_since": "Verdensmester i {{league}} siden {{date}}",
    "view_european_champion": "Europamestertrøje",
    "european_champion_since": "Europamester i {{league}} siden {{date}}",
    "view_worldcup_leader": "Verdenspokaltrøje",
    "worldcup_leader_since": "Fører af stillingen i {{league}} siden {{date}}",
    "kits_show": "Show team kits (admin)",
    "kits_hide": "Hide team kits",
    "kits_hint": "Team jerseys imported from PCS: check colours and design. Kits are fixed in the database.",
    "kits_approx": "approximate",
    "kits_men": "Men",
    "kits_women": "Women",
    "kits_wt": "WorldTeam",
    "kits_pro": "ProTeam",
    "kits_tap": "tap a team to see its riders",
    "kits_no_riders": "No avatars for this team yet.",
    "avatar_edit": "Rediger avatar",
    "avatar_cut": "Frisure",
    "avatar_hair": "Hår",
    "avatar_skin": "Hud",
    "avatar_beard": "Skæg",
    "avatar_beard_none": "Ingen",
    "avatar_face": "Ansigt",
    "avatar_face_none": "Standard",
    "avatar_face_a": "Smalt",
    "avatar_face_b": "Kraftigt",
    "avatar_face_c": "Ungt",
    "avatar_face_d": "Kantet",
    "avatar_face_e": "Modent",
    "avatar_face_f": "Smilende",
    "avatar_face_g": "Lukket smil",
    "avatar_brow": "Øjenbryn",
    "avatar_brow_0": "Normale",
    "avatar_brow_1": "Tynde",
    "avatar_brow_2": "Kraftige",
    "avatar_beard_light": "Let",
    "avatar_hex": "Anden farve (#RRGGBB)",
    "avatar_save": "Gem",
    "avatar_reset": "Nulstil",
    "avatar_undo": "Fortryd sidste ændring",
    "avatar_saved": "Gemt",
    "avatar_bad_hex": "Ugyldig farve: brug #RRGGBB",
    "avatar_err": "Kunne ikke gemme",
    "avatar_beard_legend": "1 skygge · 2 overskæg · 3 kort · 4 fuldskæg · 6 overskæg+hageskæg · 7 cirkel · 8 let skægstubbe",
    "hair_wavy_medium": "Mellembølget",
    "hair_receding": "Fremskudt hårgrænse",
    "hair_messy": "Rodet",
    "hair_buzz": "Meget kort",
    "hair_curly_short": "Korte krøller",
    "hair_medium": "Skulderlangt",
    "hair_flip_off": "Normal side",
    "hair_flip_on": "Spejlvendt",
    "hair_side_part": "Sideskilning",
    "hair_slicked_back": "Redt tilbage",
    "hair_forward": "Fremad",
    "hair_high_line": "Høj hårgrænse",
    "hair_wavy_short": "Kort bølget",
    "hair_curly_medium": "Mellemlange krøller",
    "hair_receding_short": "Kort med vige",
    "beard_stubble_light": "Let skægstubbe",
    "hair_long": "Langt",
    "hair_ponytail": "Hestehale",
    "hair_bun": "Knold",
    "hair_long_wavy": "Bølget",
    "hair_braid": "Fletning",
    "beard": "Skæg",
    "beard_none": "Ingen",
    "beard_stubble": "Skygge",
    "beard_moustache": "Overskæg",
    "beard_short": "Kort",
    "beard_full": "Fuldskæg",
    "beard_goatee": "Overskæg og hageskæg",
    "beard_circle": "Cirkelskæg",
    "beard_op_normal": "Normal",
    "beard_op_light": "Let",
    "fringe": "Pandehår",
    "fringe_off": "Uden",
    "fringe_on": "Med pandehår"
  },
  "app_update": {
    "title": "Ny version klar",
    "body": "Genstart appen for at få de nyeste ændringer.",
    "restart": "Genstart",
    "later": "Senere"
  },
  "avatar": {
    "invite_title": "Her er din avatar!",
    "invite_body": "Vi har lavet en til dig: tilpas den, som du vil.",
    "invite_cta": "Tilpas",
    "invite_dismiss": "Luk",
    "edit_a11y": "Tilpas din avatar"
  },
  "jersey_celebration": {
    "ok": "Fantastisk!"
  },
  "insight": {
    "you": "Med dig",
    "form": "Form",
    "never": "Aldrig valgt af dig: det ville være første gang.",
    "picked": "Gange valgt",
    "avg_rank": "Gns. placering",
    "avg_gap": "Gns. efterslæb",
    "best": "Bedste resultat",
    "dnf": "Udgåede med dig",
    "last": "Sidste gang",
    "retired": "udgået",
    "form_avg": "Gns. af de seneste 5",
    "season_races": "Løb i sæsonen",
    "top10": "Top 10",
    "wins": "Sejre",
    "dnfs": "Udgåede",
    "cat_1": "Flade etaper",
    "cat_2": "Bjergetaper",
    "cat_3": "Kuperede etaper",
    "last5": "Seneste 5 resultater",
    "no_results": "Ingen resultater endnu i denne sæson.",
    "open_a11y": "Indsigt om {{name}}",
    "summary": "{{n}}× med dig · gns. {{rank}}.",
    "summary_never": "Aldrig valgt af dig",
    "open": "Indsigt"
  },
  "badges": {
    "title": "Badges",
    "album_title": "Trofæskab",
    "earned_of": "{{earned}} af {{total}} badges",
    "open_album": "Åbn trofæskabet",
    "recent": "Senest optjent",
    "next_goals": "Mål inden for rækkevidde",
    "filter_all": "Alle",
    "filter_earned": "Optjent",
    "filter_todo": "Mangler",
    "group_gt": "Grand Tours",
    "group_monuments": "Monumenter og klassikere",
    "group_picks": "Valgkunst",
    "group_consistency": "Vedholdenhed",
    "group_league": "Ligaens stilling",
    "group_social": "Socialt",
    "group_meta": "Samling",
    "tier_1": "Bronze",
    "tier_2": "Sølv",
    "tier_3": "Guld",
    "tier_4": "Platin",
    "tier_special": "Milepæl",
    "secret_title": "Hemmelig badge",
    "secret_hint": "Find ud af det ved at spille.",
    "earned_on": "Optjent den {{date}}",
    "progress": "{{value}} af {{threshold}}",
    "rarity": "{{pct}} % af ligaen har den ({{n}} af {{m}})",
    "rarity_none": "Ingen har den endnu: du kan blive den første.",
    "seasons": "Optjente sæsoner: {{count}}",
    "complete": "Gennemført",
    "locked": "Mangler",
    "player": "Spiller",
    "none_me": "Ingen badges endnu: næste løb er din chance.",
    "none_other": "{{name}} har ingen badges endnu.",
    "empty_filter": "Intet at vise med dette filter.",
    "load_error": "Badges kunne ikke indlæses.",
    "not_enabled": "Badges er endnu ikke aktive i denne liga.",
    "fam": {
      "RE_GT": {
        "title": "Kongen af de Store Ture",
        "desc": "Vundne Grand Tours: {{n}}"
      },
      "WIN_GIRO": {
        "title": "Giroens konge",
        "desc": "Vind den samlede stilling i Giro d'Italia"
      },
      "WIN_TOUR": {
        "title": "Tourens konge",
        "desc": "Vind den samlede stilling i Tour de France"
      },
      "WIN_VUELTA": {
        "title": "Vueltaens konge",
        "desc": "Vind den samlede stilling i Vuelta"
      },
      "GT_PODI": {
        "title": "Podier i de Store Ture",
        "desc": "Podieplaceringer i Grand Tours: {{n}}"
      },
      "GT_DAYS": {
        "title": "Dage i trøjen",
        "desc": "Dage som leder af den samlede stilling: {{n}}"
      },
      "FIRST_PINK": {
        "title": "Lyserød trøje",
        "desc": "Tag føringen i den samlede stilling i Giro d'Italia"
      },
      "FIRST_YELLOW": {
        "title": "Gul trøje",
        "desc": "Tag føringen i den samlede stilling i Tour de France"
      },
      "FIRST_RED": {
        "title": "Rød trøje",
        "desc": "Tag føringen i den samlede stilling i Vuelta"
      },
      "GT_GREEN": {
        "title": "Sprinternes konge",
        "desc": "Vundne pointkonkurrencer i Grand Tours: {{n}}"
      },
      "GT_POIS": {
        "title": "Bjergenes konge",
        "desc": "Vundne bjergkonkurrencer i Grand Tours: {{n}}"
      },
      "GT_STAGE_WINS": {
        "title": "Etapejæger",
        "desc": "Vundne etaper i Grand Tours: {{n}}"
      },
      "GT_WIRE": {
        "title": "Fra start til slut",
        "desc": "Led den samlede stilling fra første til sidste etape og vind Grand Touren"
      },
      "GT_COMEBACK": {
        "title": "Comeback",
        "desc": "Vind en Grand Tour, selvom du var uden for top 10 efter første uge"
      },
      "GT_TRIPLE_JERSEY": {
        "title": "Total triumf",
        "desc": "Vind samlet, point og bjerg i samme Grand Tour"
      },
      "GT_HEARTBREAK": {
        "title": "Det hårde slag",
        "desc": "Du førte aftenen før sidste etape, men vandt ikke Grand Touren"
      },
      "TRIPLE_CROWN": {
        "title": "Triple Crown",
        "desc": "Vind Giro, Tour og Vuelta"
      },
      "THE_DOUBLE": {
        "title": "The Double",
        "desc": "Vind Giro og Tour i samme år"
      },
      "RE_MONUMENTI": {
        "title": "Monumenternes konge",
        "desc": "Vundne Monumenter: {{n}}"
      },
      "WIN_SANREMO": {
        "title": "La Classicissima",
        "desc": "Vind Milano-Sanremo"
      },
      "WIN_FIANDRE": {
        "title": "Flandern Rundt",
        "desc": "Vind Flandern Rundt"
      },
      "WIN_ROUBAIX": {
        "title": "Nordens helvede",
        "desc": "Vind Paris-Roubaix"
      },
      "WIN_LIEGI": {
        "title": "La Doyenne",
        "desc": "Vind Liège-Bastogne-Liège"
      },
      "WIN_LOMBARDIA": {
        "title": "De døde blades løb",
        "desc": "Vind Lombardiet Rundt"
      },
      "MONUMENTS_SWEEP": {
        "title": "Alle Monumenter",
        "desc": "Vind alle 5 Monumenter"
      },
      "RE_DEL_NORD": {
        "title": "Nordens konge",
        "desc": "Vind Flandern og Roubaix i samme år"
      },
      "ARDENNES": {
        "title": "Ardenner-trippel",
        "desc": "Vind Amstel, Flèche Wallonne og Liège i samme år"
      },
      "DUE_MARI": {
        "title": "De to haves løb",
        "desc": "Vind Paris-Nice og Tirreno-Adriatico i samme år"
      },
      "MODALITA_POGACAR": {
        "title": "Pogačar-tilstand",
        "desc": "Vind alle 3 Grand Tours og alle 5 Monumenter"
      },
      "RE_CLASSICHE": {
        "title": "Klassikernes konge",
        "desc": "Vundne klassikere: {{n}}"
      },
      "RE_TAPPE": {
        "title": "Etapeløbenes konge",
        "desc": "Vundne etapeløb: {{n}}"
      },
      "WORLD_CHAMP": {
        "title": "Verdensmester",
        "desc": "Vind linjeløbet ved VM"
      },
      "EURO_CHAMP": {
        "title": "Europamester",
        "desc": "Vind linjeløbet ved EM"
      },
      "CRONOMAN": {
        "title": "Enkeltstartsrytter",
        "desc": "Vind et enkeltstartsløb ved VM eller EM"
      },
      "SOLO_WIN": {
        "title": "Solo Win",
        "desc": "Eneste i ligaen, der valgte vinderen: {{n}}"
      },
      "PROFETA": {
        "title": "Profet",
        "desc": "Vindende valg: {{n}}"
      },
      "FIUTO": {
        "title": "Næse for vindere",
        "desc": "Vindere valgt af få: {{n}}"
      },
      "LEAGUE_WINS": {
        "title": "Løbsvinder",
        "desc": "Vundne løb i ligaen: {{n}}"
      },
      "LEAGUE_PODI": {
        "title": "Fast podiegæst",
        "desc": "Podieplaceringer i ligaens løb: {{n}}"
      },
      "DEBUTTO": {
        "title": "Debut",
        "desc": "Spil dit første løb"
      },
      "PRESENZE": {
        "title": "Fremmøde",
        "desc": "Spillede løb: {{n}}"
      },
      "SERIE": {
        "title": "På stime",
        "desc": "Spillede løb i træk: {{n}}"
      },
      "STAGIONE_PERFETTA": {
        "title": "Perfekt sæson",
        "desc": "Spil alle sæsonens løb"
      },
      "LEADER_STAGIONE": {
        "title": "Ved roret",
        "desc": "Løb afsluttet i spidsen af stillingen: {{n}}"
      },
      "CAMPIONE_LEGA": {
        "title": "Ligamester",
        "desc": "Afslut sæsonen som nummer 1 i stillingen"
      },
      "PODIO_LEGA": {
        "title": "Ligapodie",
        "desc": "Afslut sæsonen på podiet i stillingen"
      },
      "TOP10_LEGA": {
        "title": "Top 10",
        "desc": "Afslut sæsonen blandt de 10 bedste i stillingen"
      },
      "SCALATORE": {
        "title": "Klatrer",
        "desc": "Placeringer vundet i ét enkelt løb: {{n}}"
      },
      "AMMAZZAGIANTI": {
        "title": "Kæmpedræber",
        "desc": "Løb afsluttet foran lederen af stillingen: {{n}}"
      },
      "ALBUM": {
        "title": "Album",
        "desc": "Optjente badges: {{n}}"
      },
      "LEGGENDA": {
        "title": "Legende",
        "desc": "Optjen alle badges"
      }
    },
    "celebration_one": "Ny badge!",
    "celebration_many": "{{n}} nye badges!",
    "celebration_more": "og {{n}} mere",
    "share": "Del",
    "share_label": "BADGE OPTJENT",
    "share_dialog": "Min badge: {{name}}",
    "share_text": "Jeg har optjent badget “{{name}}” på Virtua Cycling! {{site}}",
    "showcase_title": "Fremhævet",
    "showcase_hint": "Vælg op til 3 badges at vise frem. Vælger du ikke, viser vi dine sjældneste.",
    "showcase_edit": "Rediger",
    "showcase_auto": "Automatisk",
    "showcase_save": "Gem",
    "showcase_count": "{{n}} af 3 valgt",
    "showcase_err": "Valget kunne ikke gemmes.",
    "showcase_a11y": "Dine fremhævede badges",
    "showcase_none": "Optjen dit første badge for at se det her.",
    "showcase_pick_empty": "Du har endnu ingen badges til vitrinen.",
    "jerseys_title": "Trøjer fra Grand Tours",
    "jersey_pink": "Lyserød trøje",
    "jersey_yellow": "Gul trøje",
    "jersey_red": "Rød trøje",
    "days_caption": "Dage i trøjen",
    "section_jerseys": "Trøjer",
    "special_title": "Specialtrøjer",
    "special_now": "I brug nu",
    "trophy_sub": "Badges, trøjer og æresliste"
  },
  "rivalry": {
    "title": "Udfordringer",
    "intro": "Vælg en modstander. Hvis vedkommende accepterer, får den der ender foran den anden et point fra det løb. Hele ligaen kan se, hvordan det går.",
    "slots": "Sendte udfordringer: {{used}} af {{max}}",
    "limit_reached": "Du har sendt det maksimale antal udfordringer. Annuller eller afslut én for at sende en ny.",
    "no_candidates": "Der er ingen andre spillere at udfordre.",
    "challenge_cta": "Send en udfordring",
    "pick_title": "Hvem vil du udfordre?",
    "confirm_challenge": "Udfordre {{name}}? Vedkommende modtager anmodningen og kan acceptere eller afvise.",
    "sent": "Anmodning sendt til {{name}}.",
    "accepted": "Du har accepteret udfordringen med {{name}}.",
    "incoming_title": "Modtagne anmodninger",
    "incoming_line": "{{name}} udfordrer dig",
    "accept": "Accepter",
    "decline": "Afvis",
    "waiting_title": "Venter på svar",
    "waiting_line": "Venter på {{name}}",
    "cancel": "Annuller",
    "mine_title": "Dine udfordringer",
    "league_title": "I ligaen",
    "ended_title": "Afsluttede udfordringer: {{count}}",
    "empty": "Ingen igangværende udfordringer i ligaen. Send den første!",
    "vs": "mod",
    "score_a11y": "{{a}} til {{b}}",
    "last_point": "Sidste point: {{name}} i {{race}}",
    "no_races": "Ingen løb endnu",
    "won_by": "Vundet af {{name}}",
    "drawn": "Endte uafgjort",
    "detail_title": "Udfordring",
    "results_title": "Løb for løb",
    "no_results": "Der er endnu ikke givet point.",
    "point_to": "Point til {{name}}",
    "end_cta": "Afslut udfordringen",
    "end_confirm": "Afslut udfordringen med {{name}}?",
    "rematch": "Revanche",
    "load_error": "Udfordringerne kunne ikke indlæses.",
    "err_limit": "Du har allerede sendt det maksimale antal udfordringer.",
    "err_exists": "I er allerede i en udfordring, eller en anmodning er i gang.",
    "err_invalid": "Denne anmodning er ikke længere gyldig.",
    "err_generic": "Handlingen kunne ikke gennemføres.",
    "notif_accepted": "Udfordring accepteret",
    "notif_declined": "Udfordring afvist"
  },
  "competition": {
    "men": "Men Elite",
    "women": "Women Elite",
    "aria": "Konkurrence"
  },
  "no_league": {
    "title": "Du deltager ikke i nogen {{comp}}-liga",
    "body": "Du kan deltage i en liga eller oprette en ny under Ligaer.",
    "body_official": "Du kan deltage i den officielle liga, når du vil, eller deltage i eller oprette en privat liga under Ligaer.",
    "join": "Deltag i {{name}}",
    "go_leagues": "Gå til ligaer"
  }
}
